import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./localization/i18n";
import { createPinia } from "pinia";

import "flowbite";
import "../node_modules/flowbite-vue/dist/index.css";

import "./main.css";
import "./icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
// import * as BrandIcons from "@fortawesome/free-brands-svg-icons";

// library.add(...Object.values(SolidIcons), ...Object.values(BrandIcons));
const piniaStore = createPinia();

createApp(App)
  .use(store)
  .use(piniaStore)
  .use(router)
  .use(i18n)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
